import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';

import Home from './components/home';
import Gallery from './components/gallery';
import GalleryDetail from './components/galleryDetail';
import About from './components/about';
import Contact from './components/contact';
import Page from './components/pages';


import TabbedSidebarDemo from './components/tabbedSidebar/TabbedSidebarDemo';
import UniformBuilder from './components/uniformBuilder/UniformBuilder';

import Navigation from './components/partials/navigation';
import SalesBanner from './components/partials/salesBanner';
import Footer from './components/partials/footer';

function GalleryWrapper() {
    const { slug } = useParams();
    return <Gallery slug={slug} />;
}

function PageWrapper() {
    const { slug } = useParams();
    return <Page slug={slug} />;
}

function GalleryDetailWrapper() {
    const { slug, id } = useParams();
    return <GalleryDetail slug={slug} id={id} />;
}

class App extends Component {
    render() {
        return (
            <Router>
                <div>
                    <SalesBanner />
                    <Navigation />

                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/gallery/:slug" element={<GalleryWrapper />} />
                        <Route path="/gallery/:slug/:id" element={<GalleryDetailWrapper />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/pages/:slug" element={<PageWrapper />} />
                        <Route path="/sidebar-demo" element={<TabbedSidebarDemo />} />
                        <Route path="/uniform-builder" element={<UniformBuilder />} />
                    </Routes>

                    <Footer />
                </div>
            </Router>
        );
    }
}

export default App;
// deploy trigger
